import '../../table.less';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { TableRow } from '../../../tableRow';
import { TableAppearance, Row } from '../../types';
import { TableRowAppearances } from '../../../tableRow/types';
import { LoggerHelper, CoreHelper, TranslationProps, WithCoreProps } from 'ff-shared-components-core';

export interface WithoutHeaderTableProps {
	appearance?: TableAppearance;
	/**sets the row values */
	rows?: Row[];
	/**Sets a checkbox prefix*/
	withCheckbox?: boolean;
	/**Sets a multiple checkbox prefix*/
	hasMultipleChecked?: boolean;
	/**Sets an image prefix for the table row */
	withImage?: boolean;
	/**set a base path to redirect on more details click */
	pathToRedirect?: string;
	/**Set the checkbox check*/
	isCheckboxChecked?: boolean;
	/**Sets a message in case there is no data to show */
	noDataMessage?: string;
	/**Sets an error message in case something went wrong*/
	errorMessage?: string;
	/**flag for error message */
	hasError?: boolean;
	/** serves the purpose of catching the current selected row */
	onChange?: (items: Row[]) => void;
}

type Props = WithoutHeaderTableProps & RouteComponentProps & TranslationProps;

class WithoutHeaderTableComponent extends React.PureComponent<Props> {
	selectedRows: Row[] = [];
	render(): React.ReactNode {
		const {
			rows,
			withCheckbox,
			withImage,
			pathToRedirect,
			isCheckboxChecked,
			t,
			noDataMessage = t<string>('table.noData'),
			errorMessage,
			hasError,
		} = this.props;

		return (
			<>
				<div className={`ds-table table-appearance-1-without-header`}>
					<div className="ds-table-body">
						<ul>
							{rows && rows.length !== 0 ? (
								rows.map(
									(row: Row, index: number): JSX.Element => (
										<TableRow
											onClick={(): void => {
												this.handleOnClick(row);
											}}
											isChecked={isCheckboxChecked}
											rowId={row.id}
											pathToRedirect={pathToRedirect}
											key={CoreHelper.guid() || index}
											withImage={withImage}
											withCheckbox={withCheckbox}
											columns={row.columns}
											appearance={TableRowAppearances.withoutHeader}
											isSelected={row.isSelected}
										></TableRow>
									)
								)
							) : (
								<li className="ds-table-cell">
									<div className="ds-table-cell-detail" style={{ width: '100%' }}>
										{hasError && !errorMessage ? noDataMessage : errorMessage}
									</div>
								</li>
							)}
						</ul>
					</div>
				</div>
			</>
		);
	}

	private readonly handleOnClick = (selectedRow: Row): void => {
		const { onChange, hasMultipleChecked } = this.props;
		if (this.selectedRows.find(s => s.id === selectedRow.id)) {
			this.selectedRows.splice(
				this.selectedRows.findIndex(x => x.id === selectedRow.id),
				1
			);
		} else {
			selectedRow.isSelected = true;

			// if single check we pop the value in array
			!hasMultipleChecked && this.selectedRows.pop();

			this.selectedRows.push(selectedRow);
		}

		onChange && onChange(this.selectedRows);
		LoggerHelper.log('WithoutHeader table > selected rows', this.selectedRows);
	};
}

export const WithoutHeaderTable = WithCoreProps<WithoutHeaderTableProps>(withRouter(WithoutHeaderTableComponent));
